export const SHOW_PREVIEWER = (state, props) => {
	state.isOpen = true;
	state.props = props;
};

export const HIDE_PREVIEWER = state => {
	state.isOpen = false;
	state.props = null;
};
